import { Injectable } from '@angular/core';
import { CanActivate, CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { WakeLockService } from 'app/_services/wake-lock/wake-lock.service';

export interface CanComponentDeactivate {
  canDeactivate: () => boolean;
}

@Injectable({
  providedIn: 'root'
})
export class WakeLockGuard implements CanActivate, CanDeactivate<CanComponentDeactivate> {
  
  constructor(private wakeLockService: WakeLockService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    // Activer le wake lock quand on entre dans la route
    // Le service se charge automatiquement de choisir entre API native et fallback
    const success = await this.wakeLockService.requestWakeLock();
    
    if (success) {
      console.log('Wake Lock activé pour la route:', state.url);
      
      // Informer l'utilisateur si on utilise le fallback
      if (this.wakeLockService['isUsingFallback']) {
        console.log('Utilisation du mode fallback pour Safari ancien');
      }
    } else {
      console.warn('Impossible d\'activer le Wake Lock pour la route:', state.url);
    }
    
    return true; // Toujours autoriser l'accès, même si wake lock échoue
  }

  async canDeactivate(
    component: CanComponentDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Promise<boolean> {
    // Désactiver le wake lock quand on quitte la route
    await this.wakeLockService.releaseWakeLock();
    console.log('Wake Lock désactivé pour la route:', currentState.url);
    return true;
  }
}
